<script>
  import BaseChart  from './ChartBase';
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'DashboardUsersChart',

    extends: BaseChart,

    computed: { 
      ...mapGetters('dashboards', { dataset: 'byUser'})
    },

    methods: {
      ...mapActions('dashboards', { load: 'loadByUser' }),
    },

  }
</script>
